import React from 'react'
import { Button } from 'react-bootstrap'
import ButtonLoader from '../loader/ButtonLoader'

export default function ApplyButton(props) {

    const { button_name, onClick, disable, spinner } = props

    return (
        <>

            <Button type='button' size='sm' disabled={disable} className='save_btn' onClick={onClick}>
                {spinner ?
                    <ButtonLoader />
                    :
                    button_name
                }
            </Button>
        </>
    )
}